import { render, staticRenderFns } from "./IndexMain.vue?vue&type=template&id=79c5ae0c&scoped=true"
import script from "./IndexMain.vue?vue&type=script&lang=js"
export * from "./IndexMain.vue?vue&type=script&lang=js"
import style0 from "./IndexMain.vue?vue&type=style&index=0&id=79c5ae0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5ae0c",
  null
  
)

export default component.exports